export function userDisplayName(user) {
  let displayName = user.name;
  if (user.email && user.email !== user.name) {
    displayName += ' (' + user.email + ')';
  }
  return displayName;
}



// WEBPACK FOOTER //
// ./app/utils/formatters.jsx